import React from 'react';
import Chart from 'Shared/PieChart/Chart';
import * as styles from './base.scss';
export default class EnergyChart extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let data = [];
        const protein = this.props.data.find(n => n.code === 'PRO');
        const fat = this.props.data.find(n => n.code === 'FAT');
        const carbs = this.props.data.find(n => n.code === 'CHOAVL');
        if (!!protein) {
            data.push({ value: protein.value, color: '#44a269', label: protein.displayName });
        }
        if (!!fat) {
            data.push({ value: fat.value, color: '#f85846', label: fat.displayName });
        }
        if (!!carbs) {
            data.push({ value: carbs.value, color: '#4198ff', label: carbs.displayName });
        }
        return (!!this.props.data &&
            this.props.data.length > 0 && (React.createElement("div", null,
            React.createElement(Chart, { className: styles.energyChart, data: data, radius: 145, strokeWidth: 2, stroke: '#ffffff' }))));
    }
}
